import { render, staticRenderFns } from "./ApprovalView.vue?vue&type=template&id=2e140776&scoped=true&"
import script from "./ApprovalView.vue?vue&type=script&lang=js&"
export * from "./ApprovalView.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalView.vue?vue&type=style&index=0&id=2e140776&prod&scoped=true&lang=css&"
import style1 from "./ApprovalView.vue?vue&type=style&index=1&id=2e140776&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e140776",
  null
  
)

export default component.exports